import type { Selector, State } from 'model/State';
import { getCurrentContactEmail } from '../../../auth/selectors';

export const selectSwitchedUser: Selector<string> = (state: State) => state.mac.configUser.email;

export const selectIsSwitchedUser: Selector<boolean> = (state: State) => {
  const currentContactEmail = getCurrentContactEmail(state) || '';
  const switchedUser = state.mac.configUser.email || '';
  return currentContactEmail !== '' && switchedUser !== '' && currentContactEmail !== switchedUser;
};
